import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerFooter,
  Button,
  Flex,
  Textarea,
  Text,
} from "@chakra-ui/react";
import React, { useContext, useState } from "react";
import { AppContext } from "AppProvider/AppContext";
import HeadingSS from "../Heading/HeadingSS";

type ModalProps = {
  isOpen: boolean;
  onClose?: () => void;
  commentModel: {
    selectedStatus: string;
    open: boolean;
    comment: string;
  };
  handleClose?: any;
  setCommentModel: React.Dispatch<
    React.SetStateAction<{
      selectedStatus: string;
      open: boolean;
      comment: string;
      isMulti?: boolean;
    }>
  >;
  uploadFile: () => void;
  handleGet?: () => void;
  width?: any;
  editedValues?: any;
  isMulti?: boolean;
  loading?: any;
};

export default function CommentDrawer({
  isOpen,
  commentModel,
  setCommentModel,
  uploadFile,
  width,
  handleClose,
  loading,
}: ModalProps) {
  // const { isOpen, onOpen, onClose } = useDisclosure()
  const [submitLoader, setSubmitLoader] = useState(false);
  const { toastNotify } = useContext(AppContext);
  const { accountDetails, workFlowData } = useContext(AppContext);

  function transformObject(inputObject: any) {
    const transformedObject: any = {};
    for (const key in inputObject) {
      transformedObject[key] = {
        originalValue: inputObject[key],
        editFieldValue: null,
      };
    }
    return transformedObject;
  }

  return (
    <>
      <Drawer
        placement="bottom"
        isOpen={isOpen}
        onClose={() => {
          setCommentModel({
            open: false,
            comment: "",
            selectedStatus: "approved",
          });
          // setSelectedRows([]);
        }}
        size="sm"
      >
        <DrawerOverlay />
        <DrawerContent
          boxSize={{ base: "auto", lg: `${width}` }}
          maxH="33vh"
          ml="auto"
          my="auto"
          borderRadius="md"
        >
          <DrawerHeader>
<HeadingSS
              headingSS={
                commentModel?.selectedStatus === "approved"
                  ? "Add Your Approval Comment"
                  : "Add Your Rejection Comment"
              }
            />          </DrawerHeader>
          <DrawerBody>
            <Textarea
              value={commentModel.comment}
              onChange={(e: any) =>
                setCommentModel({ ...commentModel, comment: e.target.value })
              }
              placeholder="Type your comment here..."
            />
          </DrawerBody>
          <DrawerFooter>
            <Flex justify="flex-end">
              <Button
                fontSize="sm"
                w="5rem"
                bg="green.400"
                _hover={{ bg: "green.500" }}
                color="white"
                mr={3}
                isLoading={loading}
                onClick={() => {
                  const status = commentModel.selectedStatus;
                  const comment = commentModel.comment?.trim() || "";

                  if (
                    (status === "rejected" || status === "approved") &&
                    comment === ""
                  ) {
                    toastNotify({
                      type: "error",
                      message:
                        "Please add a comment before approving or rejecting.",
                    });
                  } else {
                    uploadFile();
                  }
                }}
              >
                <Text>Yes</Text>
              </Button>
              <Button
                w="5rem"
                colorScheme="red"
                fontSize="sm"
                onClick={() => {
                  setCommentModel({
                    open: false,
                    comment: "",
                    selectedStatus: "approved",
                  });
                }}
              >
                No
              </Button>
            </Flex>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
}
